import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';
import { formatTypes } from '@zipari/shared-ds-util-format';
import { WindowService } from './../../../../shared/services/window.service';

@Component({
  selector: 'mp-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent {
  @Input() resourcesLabel = 'Resources';
  @Input() attributeList: ModelAttributeConfig[] = [];
  @Input() attributeListContext: any;
  @Input() useCustom: boolean;
  @Output() resourceClicked: EventEmitter<ModelAttributeConfig> =
    new EventEmitter();

  constructor(
    private router: Router,
    private window: WindowService,
  ) {}

  handleResourceClicked(attribute: ModelAttributeConfig) {
    if (attribute.format === formatTypes.LINK) {
      const url = attribute.route || attribute.value;
      const parsedUrl = this.router.parseUrl(url);

      if (attribute.isExternalRoute) {
        this.window.nativeWindow.open(url);
      } else {
        this.router.navigateByUrl(parsedUrl);
      }
    }
    this.resourceClicked.emit(attribute);
  }
}
